import { render, staticRenderFns } from "./ComprobantesPendientesDeCobroPorCliente.vue?vue&type=template&id=532fee14&"
import script from "./ComprobantesPendientesDeCobroPorCliente.vue?vue&type=script&lang=js&"
export * from "./ComprobantesPendientesDeCobroPorCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/lucianocolucci/Desktop/Share Windows/IngeniAR/WebProject/Syscore-mods/Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports